import React, {memo, forwardRef} from 'react';
import {usePopoverContext} from 'components/ui/Popover';

/**
 * DropdownMenuTrigger - Trigger button for DropdownMenu
 * Must be used as a child of Dropover component and with asChild pattern
 */
const DropdownMenuTrigger = memo(
	forwardRef(({children, ...props}, ref) => {
		const {handleToggle} = usePopoverContext();

		return (
			<div
				ref={ref}
				onClick={handleToggle}
				aria-haspopup="menu"
				aria-expanded={usePopoverContext().open}
				{...props}
			>
				{children}
			</div>
		);
	}),
);

DropdownMenuTrigger.displayName = 'DropdownMenuTrigger';

export default DropdownMenuTrigger;
